<template>
  <div>
    <button
      type="button"
      :class="btnClass"
      aria-label="Share"
      @click="openModal({ id: 'share-product', params: { link, customLink } })"
    >
      <i
        class="mi-share icon-20"
        :class="iconOnly ? '' : 'mr-0 sm:mr-1'"
      />
      <span
        v-if="!iconOnly"
        :class="textClass"
      >{{ t('share') }}</span>
    </button>
  </div>
</template>

<script setup lang="ts">
import { useI18n } from 'vue-i18n'

import { useModalStore } from '@/stores/ModalStore'

const { openModal } = useModalStore()

defineProps({
  link: {
    type: String,
    required: true,
  },

  customLink: {
    type: String,
    default: '',
  },

  btnClass: {
    type: String,
    default: 'btn  btn-primary p-2 rounded-pill border-0',
  },

  textClass: {
    type: String,
    default: 'hidden md:inline-block',
  },

  iconOnly: {
    type: Boolean,
    default: false,
  },
})
const { t } = useI18n()
</script>

<i18n>
  {
    "cs": {
    "share": "Sdílet"
},
    "sk": {
    "share": "Zdieľať"
},
    "pl": {
    "share": "Udostępnij"
},
    "hu": {
    "share": "Megoszt"
},
    "de": {
    "share": "Teilen"
},
    "at": {
    "share": "Teilen"
},
    "ro": {
    "share": "Împărtășit"
}
  }
</i18n>
